import { cr } from "fire-wind-water";
import Checkbox from "ant-design-vue/lib/checkbox"; // 加载 JS
import "ant-design-vue/lib/checkbox/style/css"; // 加载 CSS
import common from "./common";
import Vue from "vue";
Vue.use(Checkbox);
const checkboxMixin = {
  props: {
    field: {},
    fieldValue: "",
    fieldResult: {},
    checkFlag: false,
    fieldStyle: {
      type: String,
      default: "style1"
    }
  },
  data() {
    return {
      fieldObj: {},
      optionIds: [] //当前选中的option
    };
  },
  watch: {
    checkFlag() {
      //校验
      this.fieldObj.dirty = true;
      //输出结果到父级
      common.updateData(this, this.fieldObj);
    }
  },
  created() {
    if (this.field.fieldLevel == 4) {
      this.field.errorRequired = "请选择";
    }
    this.fieldObj = new window.$sk.Checkbox(this.field);
    // 不是读写权限禁用
    this.fieldObj.disabled = this.field.permissionType && this.field.permissionType != 'write';
    //回填数据
    if (!this.fieldValue) {
      return;
    }
    //回填数据需要清空默认值
    cr.each(this.fieldObj.listOptions, l =>{
      l.checked = false;
    })
    cr.each(this.fieldValue, m => {
      const o = this.fieldObj.listOptions.filter(b => {
        return b.optionValue == m;
      })[0];
      this.fieldObj.setValue(o, true);
    });
  },
  methods: {
    handleChange(e) {
      const o = this.fieldObj.listOptions.filter(b => {
        return b.optionId == e.target.value;
      })[0];
      this.fieldObj.setValue(o, e.target.checked);
      let selectOptionId =[];
      this.fieldObj.listOptions.filter(b => {
        if(b.checked){
          selectOptionId.push(b.optionId);
        }
      });
      //针对客户管理里面的独立选项 fieldLevel 1是全局 2是模块 4 自定义的
      if((this.field.fieldLevel==1||this.field.fieldLevel==2||this.field.fieldLevel==3)&&this.field.listOptionType=='CUSTOM'){
        selectOptionId =[];
        this.fieldObj.listOptions.filter(b => {
          if(b.checked){
            selectOptionId.push(b.optionValue);
          }
        });
      }
      this.$emit("change",{
        displayType:this.fieldObj.displayType,
        value: selectOptionId.join(','),
        rulesInfo:this.field.rulesInfo,
        rulesCode:this.field.fieldName,
        sortBy:this.field.sortBy
      });
    },
    inputBlur(e, o) {
      this.fieldObj.setOtherValue(o.optionId, e.target.value);
    }
  }
};
export default checkboxMixin;
